<script>
/**
 * @file 套餐说明
 */

export default {
    methods: {
        toggleTabs() {
            this.$router.push({
                name: 'postpartum-plan',
                params: {
                    ...this.$route.params
                }
            });
        },
        goback() {
            this.$router.push({name: this.$route.params.refer_name});
        }
    },
    data() {
        return {
            activeIndex: 0
        };
    }
};
</script>

<template lang="pug">
.forkiss-plan-container(ref="planContainer")
    .tabs-wrapper
        .back-btn(@click="goback", data-touch="true")
        .title-box 套餐说明
    .forkiss-plan-wrapper
        section
            .section-title
                span 会员服务套餐设有有效期，有效期结束后，会员不再享有套餐权益
            .section-subtitle-box
                .sub-title
                    span 次卡套餐有效期
            ul.card-list
                li.card-item
                    .flex-item 10次套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期6个月
                li.card-item
                    .flex-item 20次套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期12个月
                li.card-item
                    .flex-item 30次套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期12个月
            .section-subtitle-box
                .sub-title
                    span 时间卡套餐有效期
            ul.card-list
                li.card-item
                    .flex-item 1个月套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期6个月
                li.card-item
                    .flex-item 2个月套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期6个月
                li.card-item
                    .flex-item 3个月套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期6个月
                li.card-item
                    .flex-item 4个月套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期12个月
                li.card-item
                    .flex-item 6个月套餐
                    .flex-item .......................
                    .flex-item.text-right 有效期12个月

        section.section-box
            .section-title
                span 时间卡套餐设有停卡权限，停卡期时间不计入套餐使用时间
            .section-subtitle-box
                .sub-title
                    span 时间卡套餐停卡说明
            ul.card-list
                li.card-item
                    .flex-item 1个月套餐
                    .flex-item .................
                    .flex-item.text-right 可停卡2次，累计不超过15天
                li.card-item
                    .flex-item 2个月套餐
                    .flex-item .................
                    .flex-item.text-right 可停卡2次，累计不超过30天
                li.card-item
                    .flex-item 3个月套餐
                    .flex-item .................
                    .flex-item.text-right 可停卡2次，累计不超过30天
                li.card-item
                    .flex-item 4个月套餐
                    .flex-item .................
                    .flex-item.text-right 可停卡2次，累计不超过60天
                li.card-item
                    .flex-item 6个月套餐
                    .flex-item .................
                    .flex-item.text-right 可停卡2次，累计不超过120天
        section.section-box
            .section-title
                span 套餐升级
            p 会员入会1个月内可无条件升级套餐，仅须补足套餐差价；
            p 超出1个月时间升级套餐，应按原套餐资费标准折算费用后再进行升级
        section.section-box
            .section-title
                span 套餐权益仅限会员本人享有，其他人不能使用
        section.section-box
            .section-title
                span 套餐是围绕会员在特定阶段所需的综合服务，不接受退费
    .hint-box
        p 套餐仅支持线下购买，
        p 欢迎至FORKISS门店咨询

</template>

<style lang="less" scoped>
.forkiss-plan-container {
    position: relative;
    display: flex;
    height: 100%;
    overflow: auto;
    flex-direction: column;
    padding-bottom: .6rem;
    font-size: .24rem;
    background-image: url(../assets/plan-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .tabs-wrapper {
        position: relative;
    }

    .back-btn {
        position: absolute;
        z-index: 22;
        top: 50%;
        transform: translateY(-50%);
        left: .2rem;
        width: .44rem;
        height: .44rem;
        background-image: url(../assets/back.svg);
        background-size: contain;
    }

    .title-box {
        color: #FFF;
        height: 1rem;
        line-height: 1rem;
        font-size: .36rem;
        text-align: center;
    }


    .forkiss-plan-wrapper {
        flex: 1;
        margin: 0 .3rem 0;
        padding: .8rem .6rem .9rem;
        border-radius: .1rem;
        background: rgb(238, 224, 210);
        color: #666;
    }

    .section-box {
        margin-top: .6rem;

        p {
            font-size: .28rem;
            line-height: 1.8;

            & + p {
                margin-top: .14rem;
            }
        }
    }
    .section-title {
        position: relative;
        display: inline-block;
        font-size: .28rem;
        margin-bottom: .2rem;

        &::after {
            content: "";
            position: absolute;
            top: .1rem;
            left: -.3rem;
            width: .14rem;
            height: .14rem;
            border-radius: 50%;
            background-color: #a4805b;
        }
    }

    .section-subtitle-box {
        position: relative;
        text-align: center;
    }
    .sub-title {
        position: relative;
        display: inline-block;
        margin-top: .2rem;
        margin-bottom: .32rem;
        font-size: .28rem;
        color: #666;
        font-weight: 600;

        span {
            position: relative;
            z-index: 2;
        }
        &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: .12rem;
            left: 0;
            bottom: 0;
            border-radius: .1rem;
            background: #e7bd90;
            z-index: 1;
        }
    }

    ul {
        list-style: none;
        padding: 0;
    }
    .card-list {
        .card-item {
            display: flex;
            padding: .24rem 0;
            border-bottom: 1px solid #E0BE9B;
        }
        .flex-item {
            flex: 1;
        }

        .text-right {
            text-align: right;
            white-space: nowrap;
        }

        & + .title {
            margin-top: .9rem;
        }
    }

    .hint-box {
        margin-top: .58rem;
        text-align: center;
        color: #FFF;

        p {
            margin-bottom: .12rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/plan-info.vue